import { MyButton, MyModal, VideoPlayer } from 'components/Atoms';
import React, { useCallback, useEffect, useState } from 'react';
import cn from 'classnames';
import { Col, Row } from 'antd';
import Icon, { NativeIcon, PrerollIcon, TVIcon } from 'components/Atoms/Icon';
import './styles.scss';
import { FormattedMessage } from 'react-intl';

const PreviewVideoModal = ({
  visible = false,
  className = '',
  deviceBtns,
  videoSrc = '',
  defaultDevice,
  onSubmit,
  onChooseDevice,
  onCloseModal,
  ...restProps
}) => {
  const [deviceType, setDeviceType] = useState('');
  const [autoPlay, setAutoPlay] = useState(false);

  const choosePreview = useCallback(
    (deviceType = '') =>
      () => {
        setDeviceType(deviceType);
        onChooseDevice(deviceType);
        setAutoPlay(true);
      },
    []
  );

  useEffect(() => {
    setAutoPlay(visible);
  }, [visible]);

  useEffect(() => {
    setDeviceType(defaultDevice);
  }, [defaultDevice]);

  return (
    <>
      <MyModal
        {...restProps}
        className={cn('preview-video', className)}
        visible={visible}
        title={<div className="text-lg"><FormattedMessage id="preview_video_modal.title" defaultMessage="Preview Video" /></div>}
        width={1180}
        onCancel={onCloseModal}
        footer={[
          <MyButton
            key="ok"
            className="site-button ant-btn-primary w-175"
            size="large"
            onClick={onSubmit}
          >
            <FormattedMessage id="common.ok" defaultMessage="OK" />
          </MyButton>,
        ]}
      >
        <Row gutter={[20, 24]}>
          <Col md={18} className="t-center">
            {videoSrc && (
              <div className={cn('video-bg', deviceType)}>
                <VideoPlayer
                  url={videoSrc}
                  height="auto"
                  pip
                  loop
                  controls={false}
                  playing={autoPlay}
                />
              </div>
            )}
          </Col>
          <Col md={6}>
            {deviceBtns.map(({ id, name, icon }) => (
              <div
                className={cn('device-button action', {
                  selected: id === deviceType,
                })}
                key={id}
                onClick={choosePreview(id)}
              >
                <div className="mb-10">
                  <Icon component={icon} />
                </div>
                {name}
              </div>
            ))}
          </Col>
        </Row>
      </MyModal>
    </>
  );
};

export default PreviewVideoModal;

PreviewVideoModal.defaultProps = {
  onSubmit: () => {},
  onChooseDevice: (device) => {},
  onCloseModal: () => {},
  defaultDevice: 'tv',
  deviceBtns: [
    {
      id: 'tv',
      name: 'Connected TV',
      icon: TVIcon,
    },
    {
      id: 'pre-roll',
      name: 'Pre-roll',
      icon: PrerollIcon,
    },
    {
      id: 'native',
      name: 'Native',
      icon: NativeIcon,
    },
  ],
};
